/* Palazzina Wellness – eigenes, kleines Skript ohne Abhängigkeiten (kein jQuery). */
(function () {
  'use strict';
  var PW = window.PW || { routes: {}, t: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Dialoge (Mobil-Navigation, Warenkorb) ---------- */
  var lastTrigger = null;
  function openDialog(d, trigger) {
    if (!d) return;
    lastTrigger = trigger || document.activeElement;
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else { d.setAttribute('open', ''); }
    document.documentElement.style.overflow = 'hidden';
    if (trigger && trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'true');
  }
  function closeDialog(d) {
    if (!d) return;
    if (typeof d.close === 'function' && d.open) d.close(); else d.removeAttribute('open');
  }
  $$('dialog').forEach(function (d) {
    d.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    });
    d.addEventListener('click', function (e) {
      if (e.target === d) closeDialog(d); /* Klick auf den Hintergrund */
      if (e.target.closest('[data-close-dialog]')) closeDialog(d);
    });
  });
  var navBtn = $('[data-open-nav]');
  var navDialog = $('[data-nav-dialog]');
  if (navBtn) navBtn.addEventListener('click', function () { openDialog(navDialog, navBtn); });
  if (navDialog) navDialog.addEventListener('click', function (e) { if (e.target.closest('a[href]')) closeDialog(navDialog); });

  /* ---------- Mega-Menü (Desktop): Hover mit Verzögerung, Klick, Tastatur ---------- */
  var mega = $('[data-mega]');
  if (mega) {
    var triggers = $$('[data-mega-trigger]', mega);
    var openTimer = null, closeTimer = null;
    var setOpen = function (btn, open) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.hidden = !open;
    };
    var closeAll = function (except) { triggers.forEach(function (b) { if (b !== except) setOpen(b, false); }); };
    triggers.forEach(function (btn, i) {
      var li = btn.parentElement;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        closeAll(btn); setOpen(btn, open);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault(); closeAll(btn); setOpen(btn, true);
          var first = $('a', document.getElementById(btn.getAttribute('aria-controls'))); if (first) first.focus();
        } else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var next = triggers[(i + (e.key === 'ArrowRight' ? 1 : triggers.length - 1)) % triggers.length]; next.focus();
        }
      });
      li.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: none)').matches) return;
        clearTimeout(closeTimer); clearTimeout(openTimer);
        openTimer = setTimeout(function () { closeAll(btn); setOpen(btn, true); }, 150);
      });
      li.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { setOpen(btn, false); }, 200);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = triggers.filter(function (b) { return b.getAttribute('aria-expanded') === 'true'; })[0];
      if (open) { setOpen(open, false); open.focus(); }
    });
    mega.addEventListener('focusout', function (e) { if (!mega.contains(e.relatedTarget)) closeAll(); });
    document.addEventListener('click', function (e) { if (!mega.contains(e.target)) closeAll(); });
  }

  /* ---------- Warenkorb ---------- */
  var cartDrawer = $('[data-cart-drawer]');
  var isCartPage = document.body.classList.contains('tpl-cart');
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = !count; });
  }
  function renderDrawer(html) {
    if (!html || !cartDrawer) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = $('[data-cart-drawer]', tmp);
    if (fresh) cartDrawer.innerHTML = fresh.innerHTML;
  }
  function refreshCount() {
    return fetch(PW.routes.cart + '.js', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); });
  }
  $$('[data-open-cart]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!cartDrawer || isCartPage) return;
      e.preventDefault(); openDialog(cartDrawer, a);
    });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty][data-line]');
    if (!b) return;
    b.disabled = true;
    fetch(PW.routes.cartChange + '.js', {
      method: 'POST', headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ line: Number(b.getAttribute('data-line')), quantity: Number(b.getAttribute('data-qty')), sections: 'pw-cart-drawer' })
    }).then(function (r) { return r.json(); }).then(function (c) {
      if (isCartPage) { window.location.reload(); return; }
      updateCount(c.item_count);
      if (c.sections) renderDrawer(c.sections['pw-cart-drawer']);
      var st = $('[data-cart-status]'); if (st) st.textContent = PW.t.updated || '';
    }).catch(function () { b.disabled = false; });
  });

  function addToCart(form, msgEl, btn) {
    var fd = new FormData(form);
    fd.append('sections', 'pw-cart-drawer');
    if (btn) btn.disabled = true;
    if (msgEl) { msgEl.textContent = ''; msgEl.classList.remove('form-msg--error'); }
    return fetch(PW.routes.cartAdd + '.js', { method: 'POST', headers: { accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.disabled = false;
        if (!res.ok) {
          if (msgEl) { msgEl.textContent = res.j.description || res.j.message || PW.t.error; msgEl.classList.add('form-msg--error'); }
          return;
        }
        if (res.j.sections) renderDrawer(res.j.sections['pw-cart-drawer']);
        refreshCount();
        if (msgEl) msgEl.textContent = PW.t.added;
        openDialog(cartDrawer, btn);
      })
      .catch(function () { if (btn) btn.disabled = false; form.submit(); });
  }
  var pForm = $('[data-product-form]');
  if (pForm) {
    pForm.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(pForm, $('[data-form-msg]', pForm), $('[data-add-btn]', pForm));
    });
    var vs = $('[data-variant-select]', pForm);
    if (vs) vs.addEventListener('change', function () {
      var opt = vs.options[vs.selectedIndex];
      var price = opt.getAttribute('data-price');
      var cur = $('[data-price] .price__current'); if (cur) cur.textContent = price;
      var sp = $('[data-sticky-price]'); if (sp) sp.textContent = price;
      var u = new URL(window.location.href); u.searchParams.set('variant', vs.value);
      history.replaceState(null, '', u.toString());
    });
    /* Sticky-Kaufleiste (mobil), sobald der Hauptbutton aus dem Bild ist */
    var sticky = $('[data-sticky-buy]');
    var mainBtn = $('[data-add-btn]', pForm);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $('[data-sticky-add]', sticky).tabIndex = show ? 0 : -1;
      }).observe(mainBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', function () { pForm.requestSubmit ? pForm.requestSubmit() : pForm.submit(); });
    }
  }
  $$('[data-quick-add]').forEach(function (f) {
    f.addEventListener('submit', function (e) { e.preventDefault(); addToCart(f, null, $('button', f)); });
  });

  /* ---------- Galerie ---------- */
  var g = $('[data-gallery]');
  if (g) {
    var track = $('[data-gallery-track]', g);
    var slides = $$('li', track);
    var idxEl = $('[data-gallery-index]', g);
    var thumbs = $$('[data-gallery-thumb]', g);
    var current = 0, ticking = false;
    var go = function (i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) {
          current = i;
          if (idxEl) idxEl.textContent = i + 1;
          thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        }
      });
    }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.getAttribute('data-gallery-thumb'))); }); });
    var prev = $('[data-gallery-prev]', g), next = $('[data-gallery-next]', g);
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
  }

  /* ---------- Produktreihen: Pfeile (Desktop) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-row-prev],[data-row-next]');
    if (!b) return;
    var row = document.getElementById(b.getAttribute('data-row-prev') || b.getAttribute('data-row-next'));
    if (row) row.scrollBy({ left: (b.hasAttribute('data-row-next') ? 1 : -1) * row.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------- Filter: automatisch absenden ---------- */
  var facets = $('[data-facets]');
  if (facets) {
    facets.addEventListener('change', function (e) {
      if (!e.target.matches('[data-autosubmit]')) return;
      var params = new URLSearchParams(new FormData(facets));
      var clean = new URLSearchParams();
      params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      window.location.search = clean.toString();
    });
    $$('.facet', facets).forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) $$('.facet', facets).forEach(function (o) { if (o !== d) o.open = false; }); });
    });
  }

  /* ---------- Empfehlungen "Passend dazu" (erst bei Bedarf laden) ---------- */
  $$('[data-recs]').forEach(function (sec) {
    var load = function () {
      var base = sec.getAttribute('data-url');
      var get = function (intent) {
        return fetch(base + '&intent=' + intent).then(function (r) { return r.text(); }).then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          return $('ul', tmp);
        });
      };
      get('complementary').then(function (ul) { return ul || get('related'); }).then(function (ul) {
        if (!ul) return;
        $('[data-recs-target]', sec).appendChild(ul);
        sec.hidden = false;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(sec.parentElement);
    } else { load(); }
  });

  /* ---------- Kontaktformular: Thema aus URL übernehmen (?thema=...) ---------- */
  var topic = $('[data-topic-from-url]');
  if (topic) {
    var t = new URLSearchParams(window.location.search).get('thema');
    if (t) topic.value = t.slice(0, 200);
  }
})();
